import React from 'react';
import styles from './OptionsPanel.scss';
import Button from './../Toolbar/Button';
import classNames from 'classnames';

function OptionsPanel({ value, setValue, options, customStyles }) {
  return (
    <div className={classNames(styles.optionsPanel, customStyles)}>
      {options.map(({ key, icon, extraClass, label }) => (
        <Button
          key={key}
          id={key}
          icon={icon}
          active={value == key}
          onClick={() => setValue(key)}
          extraClass={[extraClass]}
          label={label}
        />
      ))}
    </div>
  );
}

export default OptionsPanel;
